import React from "react";
import { useState,useEffect,useRef } from "react";
import { Helmet } from 'react-helmet';
import SalespersonSidebar from "./SalespersonSidebar";
import ScoutRequestReportView from "./ScoutRequestReportView";
import './classes/ScoutRequestReportView.css';
import './classes/ScoutingRequestsForm.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';
import Select from 'react-dropdown-select';
import PhoneInput, {
  isValidPhoneNumber,getCountryCallingCode
} from 'react-phone-number-input';

const ScoutRequestReportEdit = () => {

    const initialForm = {
        players_first_name:'',
        players_last_name:'',
        players_age:'',
        sport_played:'',
        currently_playing_for:'',
        position_played:'',
        players_country:'',
        players_state:'',
        players_ranking_website:'',
        players_video_link:'',
        first_name:'',
        last_name:'',
        email:'',
        phone:'',
        street_address:'',
        relationship_with_player:'',
        are_you_an_smww_agent_advisor:'',
        notes:'',
        // showStateField: false,
        sid:'',
        pageURL:window.location.href
    };

    const [formData, setFormData] = useState(initialForm);
    const [isLoading, setIsLoading] = useState(true);
    const [toggle, setToggle] = useState(2);
    const [data, setData] = useState({});
    const [nextId, setNextId] = useState({});
    const [prevId, setPrevId] = useState({});
    const [scoutPicture, setScoutPicture] = useState({});
    const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
    const [fieldErrors, setFieldErrors] = useState({});
    const [countriesList, setCountriesList] = useState([]);
    const [statelist, setStateList] = useState({});
    const [selectedcountry, setSelectedCountry] = useState([]);
    const [errors, setErrors] = useState([]);
    const[success,setSuccess] = useState('');
    const [errortext,  setErrorText] = useState('');
    const navigate = useNavigate();
    const {sid} = useParams();
    const {tab} = useParams();
    const app_url = configData.APP_URL;
    const [showStateField, setShowStateField] = useState(true);
    const [buttonText, setButtonText] = useState('Submit');
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const inputStyle = {
        players_first_name: {
            border: fieldErrors.players_first_name ? '2px solid red' : '1px solid #777'
        },
        players_last_name: {
            border: fieldErrors.players_last_name ? '2px solid red' : '1px solid #777'
        },
        players_age: {
            border: fieldErrors.players_age ? '2px solid red' : '1px solid #777'
        },
        sport_played: {
            border: fieldErrors.sport_played ? '2px solid red' : '1px solid #777'
        },
        currently_playing_for: {
            border: fieldErrors.currently_playing_for ? '2px solid red' : '1px solid #777'
        },
        position_played: {
            border: fieldErrors.position_played ? '2px solid red' : '1px solid #777'
        },
        players_country: {
            border: fieldErrors.players_country ? '2px solid red' : '1px solid #777'
        },
        players_state: {
            border: fieldErrors.players_state  ? '2px solid red' : '1px solid #777'
        },
        first_name: {
            border: fieldErrors.first_name ? '2px solid red' : '1px solid #777'
        },
        last_name: {
            border: fieldErrors.last_name ? '2px solid red' : '1px solid #777'
        },
        email: {
            border: fieldErrors.email ? '2px solid red' : '1px solid #777'
        },
        phone: {
            border: fieldErrors.phone ? '2px solid red' : '1px solid #777'
        },
        street_address: {
            border: fieldErrors.street_address ? '2px solid red' : '1px solid #777'
        },
        relationship_with_player: {
            border: fieldErrors.relationship_with_player ? '2px solid red' : '1px solid #777'
        },
    };

    const handleOpen = () => {
        setSelectedCountry([]);
        setFormData(prevState => ({
        ...prevState,
        players_country:''
        }));

    };

    const handleChange = (input) => {
        // Normal input event
        if (input?.target) {
            const { name, value } = input.target;

            // Country-specific logic
            if (name === 'players_country') {
            if (value === 'US' || value === 'CA') {
                setFormData((prev) => ({
                ...prev,
                [name]: value,
                players_state:'',
                }));
                setShowStateField(true);
            } else {
                setFormData((prev) => ({
                ...prev,
                [name]: value,
                players_state:'',
                }));
                setShowStateField(false);
            }
            } else {
            // Normal field update
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            }
        } else {
            // Handle custom input (like react-dropdown-select) if needed
            console.error("handleChange called incorrectly:", input);
        }
    };

    useEffect(() => {
        Promise.all([
            getscoutrequestview(),
            retrieveUserLoggedinroles(),
            retrieveCountriesList(),
            retrieveStateList(),
        ])
        .then(() => {
            setIsLoading(false);
        })
        
    },[]);

    const updateToggle = (id) => {
        setToggle(id);
        if(id == 1) { 
            navigate("/node/841/submission/"+sid);
        }
        if(id == 2) { 
            navigate("/node/841/submission/"+sid+"/edit");
        } 
        if(id == 3) { 
            navigate("/node/841/submission/"+sid+"/delete");
        }
    }

    useEffect(() => {
        if(tab == "view") {
            setToggle(1);
        }
        if(tab == "edit") {
            setToggle(2);
        }
        if(tab == "delete") {
            setToggle(3);
        }
    } ,[tab]);

    async function getscoutrequestview() {
        const response = await fetch(
            app_url+'smwwscout/getscoutrequestview?sid='+sid,
            {
            method: "GET",
        
            headers: {
                'Content-Type': 'application/json',
            },
            }
        )           
        const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
            setData(responsedata.data.result);
            setFormData(responsedata.data.details);
            //   setFormData({
            //     ...responsedata.data.details,
            //      showStateField:
            //          responsedata.data.details.players_country === "US" ||
            //          responsedata.data.details.players_country === "CA",
            //     //players_state: responsedata.data.details.players_state
            //   });
            // setSelectedCountry(responsedata.data.details.players_country);
            setShowStateField(
                responsedata.data.details.players_country === "US" ||
                responsedata.data.details.players_country === "CA"
            );
            setScoutPicture(responsedata.data.picture);
            setNextId(responsedata.data.next_id);
            setPrevId(responsedata.data.prev_id);
        }
        if(responsedata.data.msg === "Error") {
            setErrorText(responsedata.data.result);
        } 
    }

    useEffect(() => {
        if (formData.players_country === "US" || formData.players_country === "CA") {
            setShowStateField(true);
        } else {
            setShowStateField(false);
            setFormData(prev => ({ ...prev, players_state: '' }));
        }
    }, [formData.players_country]);

    useEffect(() => {
        if (!formData || !countriesList.length) return;
        const selected = countriesList.find(
            item => item.value === formData.players_country
        );
        if (selected) {
            setSelectedCountry([selected]);
        }
    }, [formData, countriesList]);

    async function retrieveUserLoggedinroles() {
        try {
            setIsLoading(true);
            const response = await fetch(
            app_url+'viewprofile/getuserloggedinrolesid',
            {
                method: "GET",
                headers: {
                'Content-Type': 'application/json',
                },
            }
            )
            const responsedata = await response.json();
            if(responsedata.data.result === "Success") {
            setUserLoggedInRoles(responsedata.data.roles)
            }
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
                
        }
    }

    async function retrieveStateList() {
        const statelistresponse = await fetch(
        app_url+'smwwstates/getstatelist',
        {
            method: "GET",
            headers: {
            'Content-Type': 'application/json',
            },
        }
        )
        const statelistdata = await statelistresponse.json();
        const statelist = {};
            Object.keys(statelistdata.data.result).forEach(function(key) {
            statelist[key] = statelistdata.data.result[key];
        });
        setStateList(statelist);
    }
    
    async function retrieveCountriesList() {
        const countrieslistresponse = await fetch(
        app_url+'smwwcountries/getcountrieslist',
        {
            method: "GET",
            headers: {
            'Content-Type': 'application/json',
            },
        }
        )
        const countrieslistdata = await countrieslistresponse.json();
        setCountriesList(countrieslistdata.data.result);   
    }

    const validateForm = () => {
        const newFieldErrors = {};
        const newMessages = [];

        if (!formData.players_first_name) {
            newFieldErrors.players_first_name = true;
            newMessages.push("Player's First Name field is required.");
        }
        if (!formData.players_last_name) {
            newFieldErrors.players_last_name = true;
            newMessages.push("Player's Last Name field is required.");
        }
        if (!formData.players_age) {
            newFieldErrors.players_age = true;
            newMessages.push("Player's Age field is required.");
        }
        if (formData.players_age) {
        if (!/^\d+$/.test(formData.players_age)) {
        newFieldErrors.players_age = true;
        newMessages.push("Player's Age must contain numbers only.");   
        }
        }
        if (!formData.sport_played) {
            newFieldErrors.sport_played = true;
            newMessages.push("Player's Sport field is required.");
        }
        if (!formData.currently_playing_for) {
            newFieldErrors.currently_playing_for = true;
            newMessages.push("Team Which the Player is On field is required.");
        }
        if (!formData.position_played) {
            newFieldErrors.position_played = true;
            newMessages.push("Player's Position field is required.");
        }
        if (!formData.players_country) {
            newFieldErrors.players_country = true;
            newMessages.push("Where to Scout the Player field is required.");
        }
        if (formData.players_country == "US") {
        if (!formData.players_state) {
            newFieldErrors.players_state = true;
            newMessages.push("Player State is required.");
        }
        }
        if (!formData.first_name) {
            newFieldErrors.first_name = true;
            newMessages.push("Your First Name field is required.");
        }
        if (!formData.last_name) {
            newFieldErrors.last_name = true;
            newMessages.push("Your Last Name field is required.");
        }
        if (!formData.email) {
        newFieldErrors.email = true;
        newMessages.push("Your Email Address field is required.");
        } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
        newFieldErrors.email = true;
        newMessages.push("Invalid Email Format.");
        }

        // REQUIRED CHECK (fix for your issue)
        if (!formData.phone || formData.phone.trim() === "") {
        newFieldErrors.phone = true;
        newMessages.push("Your Phone Number field is required.");
        }

        // Phone validation block (your logic, fixed)
        if (formData.phone && formData.phone.trim()) {
        const digitsOnly = formData.phone.replace(/\D/g, '');

        try {
            let codeLength = 0;

            if (formData.phoneCountry) {
            codeLength = getCountryCallingCode(formData.phoneCountry).length;
            } else {
            const match = digitsOnly.match(/^\d{1,3}/);
            if (match) codeLength = match[0].length;
            }

            if (digitsOnly.length > codeLength) {
            // Full number entered → must validate
            if (!isValidPhoneNumber(formData.phone)) {
                newFieldErrors.phone = true;
                newMessages.push('Invalid Primary Phone Number');
            }
            } else {
            // Only country code → treat as empty (NO state mutation!)
            newFieldErrors.phone = true;
            newMessages.push('Your Phone Number field is required.');
            }

        } catch (err) {
            if (!isValidPhoneNumber(formData.phone)) {
            newFieldErrors.phone = true;
            newMessages.push('Invalid Primary Phone Number');
            }
        }
        }

        if (!formData.street_address) {
            newFieldErrors.street_address = true;
            newMessages.push("Your Location field is required.");
        }

        if (!formData.relationship_with_player) {
            newFieldErrors.relationship_with_player = true;
            newMessages.push("Relationship to the Player field is required.");
        }
        setFieldErrors(newFieldErrors);
        setErrors(newMessages);

        return newMessages.length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
        setButtonText('Submitting...');
        setIsButtonDisabled(true);
        const updatedFormData = {
        ...formData,
        players_state:
            formData.players_country === 'US' || formData.players_country === 'CA'
            ? formData.players_state
            : ""
        };
            const response = await fetch(app_url+'smwwscout/editscoutreport', {
            method: 'POST',
            body: JSON.stringify(updatedFormData),
            headers: {
                'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.result === "user_updated") {
                setSuccess("Form updated successfully!");
                setButtonText('Submit');
                setIsButtonDisabled(false);
                setErrors([]);
                window.scrollTo(0, 0);
            }
            else if(data.data.result === "error") {
                
                window.scrollTo(0, 0);
            }
        } else {
            setSuccess('');
            window.scrollTo(0, 0);
        }
    };

    const handleDelete = async event => {
        event.preventDefault();
        const postData = {
            formData: formData,
        }
        // console.log(formData);
        setErrors({});
        const response = await fetch(app_url+'smwwscout/deletescoutrequestdetails', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
        });
        const data = await response.json();
        if(data.data.msg === "Success") {
            navigate("/node/841/webform-results", {state: { message: "Submission Deleted"}})
        } 
    };

    return (
        <>
         {isLoading ? (
              <Loading />
            ) : (
                <div id="main" className="scout-request-report-edit-main">
                    <div className="left"></div>
                    <div className="center left-center">
                        {errortext ? (
                        <><div dangerouslySetInnerHTML={{ __html: errortext }}></div></>
                        ) : (
                        <>
                        {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
                        <>
                            {success && (
                                        <div className="set-message-done">
                                            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span><span dangerouslySetInnerHTML={{__html: success}}></span>
                                        </div>       
                                    )}
                            <div className='button_wrap'>
                                <ul className="tabs primarya">
                                    <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}><a>View</a></li>
                                    {userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) && 
                                    <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}><a>Edit</a></li>}
                                    <li className= {toggle === 3? "active" : ""} onClick={()=> updateToggle(3)}><a>Delete</a></li>
                                </ul>      
                            </div>
                            <div  className= {toggle === 1? "show-content" : "content"}>
                                <ScoutRequestReportView />
                            </div>
                         </>
                        }
                        {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) &&
                            <>
                                <div  className= {toggle === 2? "show-content" : "content"}>
                                    <nav>
                                        {prevId &&
                                            <a href={"/node/841/submission/"+prevId+"/edit"}>Previous submission</a>
                                        }
                                        {nextId &&
                                            <a href={"/node/841/submission/"+nextId+"/edit"}>Next submission</a>
                                        }
                                    </nav>
                                    <div style={{clear: "both"}}></div>
                                    {/* Submission Info */}
                                    <fieldset>
                                        <legend>Submission information</legend>
                                        <div>
                                            <div className="scout-user-picture">
                                                {(data?.user_url) ?
                                                (<a href={data.user_url} title="View user profile.">
                                                <img
                                                    src={scoutPicture}
                                                    alt="User profile"
                                                />
                                                </a>) : (
                                                <img
                                                    src={scoutPicture}
                                                    alt="User profile"
                                                />
                                                )}
                                            </div>
                                            <div>Form: <a href={"https://"+configData.RSMWW_SCOUT_DOMAIN+"/scouting-requests"}>{data.formName}</a></div>
                                            <div>Submitted by 
                                                {(data?.user_url) ? (
                                                    <a href={data.user_url} title="View user profile.">
                                                        <span> {data.submittedBy}</span>
                                                    </a>
                                                ) : (
                                                    <span> {data.submittedBy}</span>
                                                )}
                                            </div>        
                                            <div>{data.submittedDate}</div>
                                            <div>{data?.ipAddress}</div>
                                        </div>
                                    </fieldset>
                                    <h1>Request a Free Scouting Report on a Athlete</h1>
                                    {errors.length > 0 && (
                                        <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`}}>
                                            {errors.map((item, index) => {
                                            return <>{item}<br /></>
                                            
                                            })}  
                                        </div>
                                    )}
                                   
                                    <p>Through our extensive list of Scouts worldwide, we might be able to provide you with scouting reports that already exist, create a current scouting report, or lead you to scouts who can fulfill your request.
                                        Please fill out the following form and a Scout or scouts in your region will contact you.
                                        Complete information about your scouting request will increase the likelihood of a scout contacting you. All reports are complimentary.
                                        These scouts are looking for exposure to the industry and practicing their new skills.</p>
                                    <p>Fill out our Scouting Report Request form here. Upon doing so, your request will go to a display board for scouts all over the world and they can contact you.</p>
                                    <p>* Denotes a required field.</p>
                                    <form onSubmit={handleSubmit}>
                                        <fieldset className="form-wrapper" id="edit-player-info-group">
                                            <legend><span className="fieldset-legend">Part 1: Player Information</span></legend>                        
                                            <div className="fieldset-wrapper">
                                                <div className="form-item">
                                                    <label htmlFor="edit-players-first-name">Player's First Name <span className="form-required" title="This field is required.">*</span></label>
                                                    <input 
                                                        type="text" 
                                                        id="edit-players-first-name" 
                                                        name="players_first_name" 
                                                        value={formData.players_first_name} 
                                                        size="30" 
                                                        maxLength="128" 
                                                        className={fieldErrors.players_first_name ? 'input-error' : ''}
                                                        style={inputStyle.players_first_name}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-item">
                                                    <label htmlFor="edit-players-last-name">Player's Last Name <span className="form-required" title="This field is required.">*</span></label>
                                                    <input type="text" 
                                                        id="edit-players-last-name" 
                                                        name="players_last_name" 
                                                        value={formData.players_last_name} 
                                                        size="30" 
                                                        maxLength="128" 
                                                        className={fieldErrors.players_last_name ? 'input-error' : ''}
                                                        style={inputStyle.players_last_name}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-item">
                                                    <label htmlFor="edit-players-age">Player's Age <span className="form-required" title="This field is required.">*</span></label>
                                                    <input 
                                                        type="text" 
                                                        id="edit-players-age" 
                                                        name="players_age" 
                                                        value={formData.players_age} 
                                                        size="30" 
                                                        maxLength="128" 
                                                        className={fieldErrors.players_age ? 'input-error' : ''}
                                                        style={inputStyle.players_age}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-item">
                                                    <label htmlFor="edit-sport-played">Player's Sport <span className="form-required" title="This field is required.">*</span></label>
                                                    <select 
                                                    id="edit-sport-played" 
                                                    name="sport_played" 
                                                    value={formData.sport_played}
                                                    className={fieldErrors.sport_played ? 'input-error' : ''}
                                                    style={inputStyle.sport_played}
                                                    onChange={handleChange}
                                                    >
                                                        <option value="" selected="selected">-Select-</option>
                                                        <option value="2">Baseball</option>
                                                        <option value="3">Basketball</option>
                                                        <option value="8">Cricket</option>
                                                        <option value="1">Football (American)</option>
                                                        <option value="6">Hockey</option>
                                                        <option value="46">Rugby</option>
                                                        <option value="4">Soccer</option>
                                                    </select>
                                                </div>
                                                <div className="form-itemr">
                                                    <label htmlFor="edit-currently-playing-for">Team Which the Player is On <span className="form-required" title="This field is required.">*</span></label><div className="description">If the player is a free agent, please write "Free Agent".</div>
                                                    <input 
                                                        type="text" 
                                                        id="edit-currently-playing-for" 
                                                        name="currently_playing_for" 
                                                        value={formData.currently_playing_for} 
                                                        size="30" 
                                                        maxLength="128" 
                                                        className={fieldErrors.currently_playing_for ? 'input-error' : ''}
                                                        style={inputStyle.currently_playing_for}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-item">
                                                    <label htmlFor="edit-position-played">Player's Position <span className="form-required" title="This field is required.">*</span></label>
                                                    <input 
                                                        type="text" 
                                                        id="edit-position-played" 
                                                        name="position_played" 
                                                        value={formData.position_played}
                                                        size="30" 
                                                        maxLength="128" 
                                                        className={fieldErrors.position_played ? 'input-error' : ''}
                                                        style={inputStyle.position_played}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-item">
                                                    <label htmlFor="edit-players-country">Where to Scout the Player <span className="form-required" title="This field is required.">*</span></label>
                                                    <Select                                 
                                                        id="country" 
                                                        name="players_country" 
                                                        searchable={true}                                
                                                        clearable={true} 
                                                        clearOnBlur={true} 
                                                        clearOnSelect={true}
                                                        backspaceDelete={true}  
                                                        className={`select-country ${fieldErrors.players_country ? 'input-error' : ''}`}                               
                                                        style={{
                                                            backgroundColor: '#ffffff',
                                                            width: '87.8%',
                                                            borderRadius: 5,
                                                            ...inputStyle.players_country
                                                        }}                                                  
                                                        options={countriesList}                                 
                                                        onChange={(val) => {
                                                        if(val.length == 0) {
                                                            console.log(val);
                                                        }
                                                        else{
                                                            setSelectedCountry(val);
                                                        handleChange(
                                                            { target: { value: val[0]['value'], name: 'players_country' } }
                                                        )
                                                        
                                                        }}
                                                        }
                                                        onDropdownOpen={handleOpen}
                                                        values={selectedcountry}                                 
                                                        />
                                                </div>
                                                {showStateField &&
                                                <div className="form-item">
                                                    <label htmlFor="edit-players-state">State </label>
                                                        <select  id="state" name="players_state" value={formData.players_state}  onChange={handleChange}
                                                            className={`smww-appn state-field ${fieldErrors.players_state ? 'input-error' : ''}`}
                                                            style={inputStyle.players_state}
                                                        >
                                                            <option value="">Select State</option>
                                                            {Object.keys(statelist).map(players_state => {
                                                            return <option key={statelist[players_state].name} value={statelist[players_state].name}>{statelist[players_state].name}</option>
                                                            })}
                                                        </select>
                                                </div>
                                                }
                                                <div className="form-item">
                                                    <label htmlFor="edit-players-ranking-website">Link to a Website(s) That Shows the Player's Ranking </label>
                                                    <input
                                                        type="text" 
                                                        id="edit-players-ranking-website" 
                                                        name="players_ranking_website" 
                                                        value={formData.players_ranking_website} 
                                                        size="30" 
                                                        maxLength="600" 
                                                        className="form-text"
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-item">
                                                    <label htmlFor="edit-players-video-link">Links to Any Highlight Videos </label>
                                                    <input 
                                                        type="text" 
                                                        id="edit-players-video-link" 
                                                        name="players_video_link" 
                                                        value={formData.players_video_link} 
                                                        size="30" 
                                                        maxlength="600" 
                                                        className="form-text"
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                        </fieldset>
                                        <fieldset className="form-wrapper" id="edit-requester-info-group">
                                            <legend><span className="fieldset-legend">Part 2: Requester's Information</span></legend>
                                            <div className="fieldset-wrapper">
                                                <div className="form-item">
                                                    <label htmlFor="edit-first-name">Your First Name <span className="form-required" title="This field is required.">*</span></label>
                                                    <input 
                                                        type="text" 
                                                        id="edit-first-name" 
                                                        name="first_name" 
                                                        value={formData.first_name} 
                                                        size="30" 
                                                        maxLength="128" 
                                                        className={fieldErrors.first_name ? 'input-error' : ''}
                                                        style={inputStyle.first_name}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-item">
                                                    <label htmlFor="edit-last-name">Your Last Name <span className="form-required" title="This field is required.">*</span></label>
                                                    <input 
                                                        type="text" 
                                                        id="edit-last-name" 
                                                        name="last_name"
                                                        value={formData.last_name} 
                                                        size="30" 
                                                        maxLength="128"
                                                        className={fieldErrors.last_name ? 'input-error' : ''}
                                                        style={inputStyle.last_name}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-item">
                                                    <label htmlFor="edit-email">Your Email Address <span className="form-required" title="This field is required.">*</span></label>
                                                    <input 
                                                        type="text" 
                                                        id="edit-email" 
                                                        name="email" 
                                                        value={formData.email} 
                                                        size="30" 
                                                        maxLength="128" 
                                                        className={fieldErrors.email ? 'input-error' : ''}
                                                        style={inputStyle.email}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-item phone-input">
                                                    <label htmlFor="edit-phone">Your Phone Number <span className="form-required" title="This field is required.">*</span></label>
                                                    <PhoneInput
                                                        international
                                                        countryCallingCodeEditable={false}
                                                        placeholder="Enter phone number"
                                                        className={`smww-appn ${fieldErrors.phone ? 'input-error' : ''}`} 
                                                        style={inputStyle.phone}
                                                        value={formData.phone}
                                                        defaultCountry={formData.phoneCountry || 'US'}
                                                        onCountryChange={(country) => {
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            phoneCountry: country,
                                                        }));
                                                        }}
                                                        onChange={(phone) => {
                                                            if (!phone) {
                                                            console.log('Phone input cleared.');
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                phone: '',
                                                            }));
                                                            return;
                                                            }
                                                            const digitsOnly = phone.replace(/\D/g, '');
                                                            let codeLength = 0;
                                                            if (formData.phoneCountry) {
                                                            codeLength = getCountryCallingCode(formData.phoneCountry).length;
                                                            } else {
                                                            const match = digitsOnly.match(/^\d{1,3}/);
                                                            if (match) {
                                                                codeLength = match[0].length;
                                                            }
                                                            }
                                                            if (digitsOnly.length <= codeLength) {
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                phone: '',
                                                            }));
                                                            } else {
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                phone: phone,
                                                            }));
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-item">
                                                    <label htmlFor="edit-street-address">Your Location <span className="form-required" title="This field is required.">*</span></label>
                                                    <input 
                                                        type="text" 
                                                        id="edit-street-address" 
                                                        name="street_address" 
                                                        value={formData.street_address} 
                                                        size="30" 
                                                        maxLength="128"
                                                        className={fieldErrors.street_address ? 'input-error' : ''}
                                                        style={inputStyle.street_address}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="form-item">
                                                    <label htmlFor="edit-relationship-with-player">Relationship to the Player <span className="form-required" title="This field is required.">*</span></label>
                                                    <select 
                                                        id="edit-relationship-with-player" 
                                                        name="relationship_with_player"
                                                        value={formData.relationship_with_player}
                                                        className={fieldErrors.relationship_with_player ? 'input-error' : ''}
                                                        style={inputStyle.relationship_with_player}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">-Select-</option>
                                                        <option value="SMWW Agent Advisor">SMWW Agent Advisor</option>
                                                        <option value="Parent">Parent</option>
                                                        <option value="Self">Self</option>
                                                        <option value="Team Executive">Team Executive</option>
                                                    </select>
                                                </div>
                                                <div className="form-item">
                                                    <label htmlFor="edit-are-you-an-smww-agent-advisor">Are You an SMWW Agent Advisor? <span className="form-required" title="This field is required.">*</span></label>
                                                    <div id="edit-are-you-an-smww-agent-advisor" className="form-radios">
                                                        <div className="form-item form-type-radio">
                                                            <input 
                                                                type="radio" 
                                                                id="edit-are-you-an-smww-agent-advisor-yes" 
                                                                name="are_you_an_smww_agent_advisor" 
                                                                value="Yes"
                                                                checked={formData.are_you_an_smww_agent_advisor === "Yes"}
                                                                onChange={handleChange}
                                                            /> 
                                                            <label className="option" htmlFor="edit-are-you-an-smww-agent-advisor-yes">Yes </label>
                                                        </div>
                                                        <div className="form-item form-type-radio">
                                                            <input
                                                                type="radio"
                                                                id="edit-are-you-an-smww-agent-advisor-no" 
                                                                name="are_you_an_smww_agent_advisor" 
                                                                value="No"
                                                                checked={formData.are_you_an_smww_agent_advisor === "No"}
                                                                onChange={handleChange}
                                                                />  
                                                            <label className="option" htmlFor="edit-are-you-an-smww-agent-advisor-no">No </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-item">
                                                    <label htmlFor="edit-notes">Any Other Notes? </label>
                                                    <input 
                                                        type="text" 
                                                        id="edit-notes" 
                                                        name="notes" 
                                                        value={formData.notes}
                                                        size="30" 
                                                        maxLength="128"
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                        </fieldset>
                                        <div className="adduser-form-actions">
                                            <input type="submit" id="edit-submit" className="form-submit" value={buttonText} disabled={isButtonDisabled} />
                                        </div>
                                        
                                    </form>  
                                    <nav>
                                        {prevId &&
                                            <a href={"/node/841/submission/"+prevId+"/edit"}>Previous submission</a>
                                        }
                                        {nextId &&
                                            <a href={"/node/841/submission/"+nextId+"/edit"}>Next submission</a>
                                        }
                                    </nav>
                                </div>
                            </>
                        }
                        {(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)) &&
                            <>
                                <div  className= {toggle === 3? "show-content" : "content"}>
                                    <form onSubmit={handleDelete}>
                                        <div>Are you sure you want to delete this submission?
                                            <div className="form-actions form-wrapper" id="edit-actions">
                                                <input type="submit" name="" value="Delete" className="form-submit" />
                                                <a href={"/node/841/submission/"+sid} style={{marginLeft: "5px"}}>Cancel</a>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </>
                        }
                        </>)}
                    </div>
                    <div className="right">
                        <SalespersonSidebar />
                    </div>
                </div>
            )}
        </>
    );
};
export default ScoutRequestReportEdit;